import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Copy, Ghost } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

export const PROMO = { code: "OCT10", ends: new Date(2026, 10, 1) };
const SEEN = "shadc_promo_oct10_seen";
const WEEK = 7 * 864e5;

const due = () => Date.now() < PROMO.ends.getTime() && !(Date.now() - Number(localStorage.getItem(SEEN)) < WEEK)
  && Boolean(localStorage.getItem("shadc_age_verified"));

export const PromoPopup = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const blocked = /^\/(checkout|cart|order-confirmation)/.test(pathname);
  useEffect(() => {
    if (blocked) return undefined;
    let t;
    const check = () => { if (due()) t = setTimeout(() => setOpen(true), 1200); };
    check();
    window.addEventListener("shadc:age-verified", check);
    return () => { clearTimeout(t); window.removeEventListener("shadc:age-verified", check); };
  }, [blocked]);
  const close = () => { localStorage.setItem(SEEN, String(Date.now())); setOpen(false); };
  const copy = async () => {
    localStorage.setItem("shadc_promo_code", PROMO.code);
    try { await navigator.clipboard.writeText(PROMO.code); toast.success("Code OCT10 copied. It'll be filled in at checkout."); }
    catch { toast.success("Code OCT10 saved. It'll be filled in at checkout."); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md overflow-hidden rounded-2xl border-gold/40 bg-panel p-0 text-center" data-testid="promo-popup">
        <div className="bg-gradient-to-b from-orange-500/25 to-transparent px-8 pb-2 pt-10">
          <Ghost className="mx-auto h-10 w-10 text-orange-400" aria-hidden />
          <p className="eyebrow mt-4">Halloween special</p>
          <DialogTitle className="mt-2 font-display text-5xl font-bold text-white">10% OFF</DialogTitle>
          <DialogDescription className="mt-3 text-base text-gray-300">Use this code at checkout on the regular menu until Halloween.</DialogDescription>
        </div>
        <div className="px-8 pb-8">
          <button type="button" onClick={copy} className="mx-auto mt-5 flex items-center gap-3 rounded-2xl border-2 border-dashed border-gold px-6 py-3 font-display text-3xl font-bold tracking-[0.2em] text-gold transition-colors hover:bg-gold/10" data-testid="promo-popup-code">
            {PROMO.code}<Copy className="h-5 w-5" aria-hidden />
          </button>
          <Link to="/shop/" onClick={() => { localStorage.setItem("shadc_promo_code", PROMO.code); close(); }} className="btn-gold mt-6 w-full" data-testid="promo-popup-shop-button">Shop now</Link>
          <button type="button" onClick={close} className="mt-3 text-sm text-gray-400 hover:text-white" data-testid="promo-popup-dismiss">No thanks</button>
          <p className="mt-5 text-xs text-gray-500" data-testid="promo-popup-terms">Ends Oct 31. Not valid on October Deals. 21+ only.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
